import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Page, Frame, DataTable, Card, Link } from '@shopify/polaris';

import { ViewMajorMonotone } from '@shopify/polaris-icons';

const propTypes = {
  data: PropTypes.shape({
    variant: PropTypes.object.isRequired,
    logs: PropTypes.array.isRequired,
  }).isRequired,

  transferURLBase: PropTypes.string.isRequired,
  saleReportURLBase: PropTypes.string.isRequired,
  productURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

const VariantGoodsLogsScreen = (props) => {
  const { variant } = props.data;
  console.log("Logs", props);

  const generateRows = (logs) => {
    let qtyTotal = 0;
    const rows = logs.map( (log) => {
      const positive = (log.kind == "goods_in" || log.kind == "goods_in_sc");
      positive ? qtyTotal += log.quantity : qtyTotal -= log.quantity;
      return [
        I18n.t(`enum.kind.display_audit_trail.${log.kind}`), // kind / movement
        positive ? `+${log.quantity}` : `-${log.quantity}`, // Cantidad
        log.kind == "goods_out" && log.amount_money, // Monto (only displayed for sales)
        log.order_id && `#${log.order_id}`, // ID bp order
        `#${log.goods_note_id}`, // ID goods note
        <ItemLink url={ props.transferURLBase.replace("URL_ID", log.transfer_id) } content={ `#${log.transfer_id}` } />, // Transfer
        log.sale_report_id && <ItemLink url={ props.saleReportURLBase.replace("URL_ID", log.sale_report_id) } content={ `#${log.sale_report_id}` } />, // ID Sale report
        I18n.l("time.formats.long", log.goods_note_date) // date
      ]}
    );

    return { rows: rows, totals: ['', qtyTotal, '', '', '', '', '', ''] }
  }

  const genRows = useCallback( () => generateRows(props.data.logs), [variant.id] );
  const data = genRows();

  return (
    <AppProvider>
      <Frame>
        <Page 
          title={`${I18n.t("app.audit_trail")} - ${variant.title} (${variant.sku})`} fullWidth
          secondaryActions={[
            { content: "Ver Producto", url: props.productURL, external: true, icon: ViewMajorMonotone }
          ]}
        >
          <Card>
            <DataTable
              rows={ data.rows }
              totals={data.totals}
              headings={[ 
                'Movimiento', 
                'Cantidad', 
                'Monto', 
                'Orden', 
                'ID GN', 
                'Entrega APU', 
                'Reporte de Ventas', 
                'Fecha' 
              ]}
              columnContentTypes={['text', 'numeric', 'numeric', 'text', 'text', 'text', 'text' ]}
              showTotalsInFooter
            />
          </Card>
        </Page>
      </Frame>
    </AppProvider>
  )
};

const ItemLink = ({ url, content }) => (
  <Link external url={url} removeUnderline>{ content }</Link>
)

VariantGoodsLogsScreen.propTypes = propTypes;
VariantGoodsLogsScreen.defaultProps = defaultProps;

export default VariantGoodsLogsScreen;